import {
    CONTACT_US_CONFIG_LOADING,
    CONTACT_US_CONFIG_LOADING_DONE,
    CONTACT_US_CONFIG_INIT,
    CONTACT_US_CONFIG_GET,
} from '../../actions';

const INITIAL_STATE = {
    loading: false,
    config: [],
};

const contactUsConfiguration = (state = INITIAL_STATE, { type, payload }) => {
    switch (type) {
        case CONTACT_US_CONFIG_GET:
            return {
                ...state,
                config: [...payload],
            };
        case CONTACT_US_CONFIG_INIT:
            return { ...INITIAL_STATE };

        case CONTACT_US_CONFIG_LOADING:
            return {
                ...state,
                loading: true,
            };

        case CONTACT_US_CONFIG_LOADING_DONE:
            return {
                ...state,
                loading: false,
            };

        default:
            return state;
    }
};
export default contactUsConfiguration;
